import { n as R, t as A, i as S, a as M, b as C, c as x } from "./index-1fa6eebe.js";
import { watch as O, ref as v, computed as z, getCurrentInstance as B, onMounted as L } from "vue";
function y(e) {
  var t;
  const n = A(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const E = x ? window : void 0;
function b(...e) {
  let t, n, r, a;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([n, r, a] = e, t = E) : [t, n, r, a] = e, !t)
    return R;
  Array.isArray(n) || (n = [n]), Array.isArray(r) || (r = [r]);
  const u = [], i = () => {
    u.forEach((o) => o()), u.length = 0;
  }, l = (o, s, c, d) => (o.addEventListener(s, c, d), () => o.removeEventListener(s, c, d)), f = O(
    () => [y(t), A(a)],
    ([o, s]) => {
      if (i(), !o)
        return;
      const c = S(s) ? { ...s } : s;
      u.push(
        ...n.flatMap((d) => r.map((h) => l(o, d, h, c)))
      );
    },
    { immediate: !0, flush: "post" }
  ), p = () => {
    f(), i();
  };
  return M(p), p;
}
function W(e) {
  return typeof e == "function" ? e : typeof e == "string" ? (t) => t.key === e : Array.isArray(e) ? (t) => e.includes(t.key) : () => !0;
}
function N(...e) {
  let t, n, r = {};
  e.length === 3 ? (t = e[0], n = e[1], r = e[2]) : e.length === 2 ? typeof e[1] == "object" ? (t = !0, n = e[0], r = e[1]) : (t = e[0], n = e[1]) : (t = !0, n = e[0]);
  const {
    target: a = E,
    eventName: u = "keydown",
    passive: i = !1,
    dedupe: l = !1
  } = r, f = W(t);
  return b(a, u, (o) => {
    o.repeat && A(l) || f(o) && n(o);
  }, i);
}
function j() {
  const e = v(!1);
  return B() && L(() => {
    e.value = !0;
  }), e;
}
function K(e) {
  const t = j();
  return z(() => (t.value, !!e()));
}
function _(e, t, n = {}) {
  const { window: r = E, ...a } = n;
  let u;
  const i = K(() => r && "ResizeObserver" in r), l = () => {
    u && (u.disconnect(), u = void 0);
  }, f = z(() => Array.isArray(e) ? e.map((s) => y(s)) : [y(e)]), p = O(
    f,
    (s) => {
      if (l(), i.value && r) {
        u = new ResizeObserver(t);
        for (const c of s)
          c && u.observe(c, a);
      }
    },
    { immediate: !0, flush: "post", deep: !0 }
  ), o = () => {
    l(), p();
  };
  return M(o), {
    isSupported: i,
    stop: o
  };
}
function P(e, t = {}) {
  const {
    reset: n = !0,
    windowResize: r = !0,
    windowScroll: a = !0,
    immediate: u = !0
  } = t, i = v(0), l = v(0), f = v(0), p = v(0), o = v(0), s = v(0), c = v(0), d = v(0);
  function h() {
    const w = y(e);
    if (!w) {
      n && (i.value = 0, l.value = 0, f.value = 0, p.value = 0, o.value = 0, s.value = 0, c.value = 0, d.value = 0);
      return;
    }
    const m = w.getBoundingClientRect();
    i.value = m.height, l.value = m.bottom, f.value = m.left, p.value = m.right, o.value = m.top, s.value = m.width, c.value = m.x, d.value = m.y;
  }
  return _(e, h), O(() => y(e), (w) => !w && h()), a && b("scroll", h, { capture: !0, passive: !0 }), r && b("resize", h, { passive: !0 }), C(() => {
    u && h();
  }), {
    height: i,
    bottom: l,
    left: f,
    right: p,
    top: o,
    width: s,
    x: c,
    y: d,
    update: h
  };
}
export {
  P as a,
  N as o,
  b as u
};
//# sourceMappingURL=index-487dfa1c.js.map
